module.exports = __webpack_public_path__ + "static/media/foldedClothes.e9ea1d2c.svg";